import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/History_of_Sci_&_Tech_-_Medical_Breakthroughs_e.g._Vaccines_DNA.png';

function HistoryPageMedicalBreakthroughsGo() {
  return (
    <QuizPage
      title="History: Medical Breakthroughs"
      subTopic="Medical Breakthroughs (e.g., Vaccines, DNA)"
      backgroundImage={historyImage}
      returnPath="/History-Medical-Breakthroughs"
    />
  );
}

export default HistoryPageMedicalBreakthroughsGo;
